import { useManagement } from 'client/store'
import managementSelectors from 'client/store/management/managementSelectors'
import React, { useCallback } from 'react'
import { automationRuleActionItems } from 'src/editor/shared/settings/automation-rules-settings/constants/default-action-values'
import { AutomationRuleActionsEnum } from 'src/editor/shared/types/automation-rules/actions-types'
import { AURELIAN_USER_ID } from 'src/shared/constants/users-ids'
import { SettingsMenuButtonWithIcon } from '../../components/settings-menu-buttons/settings-menu-button-with-icon'

interface AddActionsListProps {
  onOpenAddAction: (slug: AutomationRuleActionsEnum) => void
}

export const AddActionsList = ({ onOpenAddAction }: AddActionsListProps) => {
  const userId = useManagement(managementSelectors.getUserId)

  const isActionAvailableFilter = useCallback(
    (action: (typeof automationRuleActionItems)[number]) => {
      // for now create user will be available only for Aurelien, because we don't have workspace information in editor
      const isRootAdmin = userId === AURELIAN_USER_ID
      if (!isRootAdmin) {
        return action.slug !== AutomationRuleActionsEnum.create_user
      } else {
        return true
      }
    },
    [userId],
  )

  return (
    <div className="flex flex-col gap-2">
      {automationRuleActionItems
        .filter(isActionAvailableFilter)
        .map((action, index) => (
          <>
            {index === 8 && <hr className="my-2 text-bgTertiary" />}
            <SettingsMenuButtonWithIcon
              key={action.slug}
              title={action.title}
              iconBefore={() => action.icon}
              onClick={() => {
                onOpenAddAction(action.slug)
              }}
            />
          </>
        ))}
    </div>
  )
}
